import {Modules, Origins} from "../../types/generalData";
import {HttpAxiosRequest} from "../httpAxiosBase";
import {
    Client,
    ClientAddress, ClientForm,
    ClientPhoneNumber,
    ClientRelationshipInsert,
    ClientRelationshipView
} from "../../types/client/clientData";
import {BaseResponseWithData} from "../../types/baseEntities";


export const HttpClient = {
    getEndpoint: (url = "") => `cliente${url}`,

    sincronizeClientByCUIT: (CUIT: string, moduleId: Modules, originId = ""): Promise<BaseResponseWithData<Client>> => {
        return HttpAxiosRequest.post(
            HttpClient.getEndpoint(`/${CUIT}/sincronizar`),
            {
                codOrigen: Origins.AppWeb,
                codModulo: moduleId,
                idEnOrigen: originId
            }
        );
    },
    
    getById: (clientId: number): Promise<Client> => {
        return HttpAxiosRequest.get(
            HttpClient.getEndpoint(`/${clientId}`)
        )
    },

    update: (cliente: ClientForm): Promise<any> => {
        return HttpAxiosRequest.put(
            HttpClient.getEndpoint(),
            cliente
        );
    }
}


export const HttpClientAddress = {
    getEndpoint: (intIdClient: number, url: string): string => `cliente/${intIdClient}/domicilios${url}`,

    getByIdClient: (intIdClient: number): Promise<ClientAddress[]> => {
        return HttpAxiosRequest.get(
            HttpClientAddress.getEndpoint(intIdClient, "")
        );
    },

    insert: (intIdClient: number, clientAdress: ClientAddress): Promise<any> => {
        return HttpAxiosRequest.post(
            HttpClientAddress.getEndpoint(intIdClient, ""),
            clientAdress
        );
    },

    update: (intIdClient: number, clientAdress: ClientAddress): Promise<any> => {
        return HttpAxiosRequest.put(
            HttpClientAddress.getEndpoint(intIdClient, ""),
            clientAdress
        );
    },
    
    delete: (intIdClient: number, idAddress: number): Promise<any> => {
        return HttpAxiosRequest.delete(
            HttpClientAddress.getEndpoint(intIdClient, `/${idAddress}`)
        );
    }
}


export const HttpClientPhone = {
    getEndpoint: (intIdClient: number, url: string): string => `cliente/${intIdClient}/telefonos${url}`,

    getByIdClient: (intIdClient: number): Promise<ClientPhoneNumber[]> => {
        return HttpAxiosRequest.get(
            HttpClientPhone.getEndpoint(intIdClient, "")
        );
    },

    insert: (intIdClient: number, clientPhoneNumber: ClientPhoneNumber): Promise<any> => {
        return HttpAxiosRequest.post(
            HttpClientPhone.getEndpoint(intIdClient, ""),
            clientPhoneNumber
        );
    },

    update: (intIdClient: number, clientPhoneNumber: ClientPhoneNumber): Promise<any> => {
        return HttpAxiosRequest.put(
            HttpClientPhone.getEndpoint(intIdClient, ""),
            clientPhoneNumber
        );
    },
}

export const HttpClientRelationships = {
    getEndpoint: (intIdCliente: number, url = ""): string => `cliente/${intIdCliente}/relacionados${url}`,

    getPorIdCliente: (intIdCliente: number): Promise<ClientRelationshipView[]> => {
        return HttpAxiosRequest.get(
            HttpClientRelationships.getEndpoint(intIdCliente)
        );
    },

    postRelacion: (intIdCliente: number, idCliente: number, relaciones: ClientRelationshipInsert[]): Promise<ClientRelationshipInsert[]> => {
        return HttpAxiosRequest.post(
            HttpClientRelationships.getEndpoint(intIdCliente),
            {idCliente: idCliente, lstRelaciones: relaciones}
        );
    },

    delete: (intIdCliente: number, idClienteRelacionado: number): Promise<string> => {
        return HttpAxiosRequest.delete(
            HttpClientRelationships.getEndpoint(intIdCliente, `/${idClienteRelacionado}`)
        );
    },
}